import { ChangeDetectionStrategy, Component, OnInit, input } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { SkeletonModule } from '@bazis/shared/components/web/skeleton/skeleton.module';

@Component({
    selector: 'bazis-gallery-skeleton',
    templateUrl: './gallery-skeleton.component.html',
    imports: [NgClass, SkeletonModule, CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GallerySkeletonComponent implements OnInit {
    readonly isPreview = input<boolean>();

    readonly cssClass = input<string>();

    ngOnInit() {}
}
